const styles = (theme) => ({
  outerMostWrapper: {
    zIndex: 2,
    position: "absolute",
    pointerEvents: "auto",
    left: 5,
    top: 5,
    maxWidth: "90%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.ComponentHeader,
    width: 582,
    maxHeight: "90%",
  },
  dialog: {
    width: 582,
  },
  stopName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  divider: {
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
  },
  stopAddress: {
    color: theme.subHeaderTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
  },
  closeButton: {
    position: "absolute",
    right: "4px",
    top: "7%",
  },
  closeButtonSize: {
    fontSize: 18,
  },
  driverNumber: {
    position: "absolute",
    fontSize: theme.textFontSize,
    top: "30%",
    right: 78,
    color: theme.gridTextColor,
  },
  driverName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "space-between",
    padding: 16,
  },
  proDetailsHeader: {
    display: "flex",
    justifyContent: "space-between",
  },
  proDetails: {
    fontSize: 10,
    color: theme.TextColor,
    opacity: 0.6,
  },
  showDetails: {
    fontSize: 10,
    color: theme.TextColor,
    opacity: 0.6,
  },
  proNumber: {
    color: theme.dispatchShipperTextColor,
    fontSize: theme.headerTextFontSize,
  },
  shipperDetails: { fontSize: 10, color: theme.TextColor, opacity: 0.6 },
  shipperName: {
    color: theme.dispatchShipperTextColor,
    fontSize: theme.textFontSize,
  },
  shipperAddress: { fontSize: theme.textFontSize, color: theme.TextColor },
  proDetailsContent: { display: "flex", justifyContent: "space-between" },
  proDetailsLabel: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    opacity: 0.6,
  },
  proDetailsValue: { fontSize: theme.textFontSize, color: theme.TextColor },
  hideDetailsContainer: { display: "flex", justifyContent: "center" },
  hideDetailsLabel: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    opacity: 0.6,
  },
  collapsibleContainer: {
    borderTop: `1px solid ${theme.gridIconBorderColor}`,
  },
  hideDetailIcon: { backgroundColor: "transparent" },
});

export default styles;
